module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/devices/display-1-6d61ecfa50ebaa38c3e09d57eb67bc05.svg";